import React from "react";
import { FaEye, FaEyeSlash, FaHandshake, FaImage } from "react-icons/fa";

function KpiCard({ label, value, detail, icon, loading, tone = "base" }) {
  const tones = {
    base: "border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900",
    info: "border-indigo-200 bg-indigo-50 dark:border-indigo-500/20 dark:bg-indigo-500/10",
    ok: "border-emerald-200 bg-emerald-50 dark:border-emerald-500/20 dark:bg-emerald-500/10",
    warn: "border-amber-200 bg-amber-50 dark:border-amber-500/20 dark:bg-amber-500/10",
    danger: "border-rose-200 bg-rose-50 dark:border-rose-500/20 dark:bg-rose-500/10",
  };

  return (
    <article
      className={`rounded-[24px] border p-4 shadow-sm ${
        tones[tone] || tones.base
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
            {label}
          </p>

          {loading ? (
            <div className="mt-3 h-7 w-20 animate-pulse rounded-xl bg-slate-200 dark:bg-slate-800" />
          ) : (
            <p className="mt-2 text-2xl font-bold text-slate-900 dark:text-white">
              {value}
            </p>
          )}

          {detail ? (
            <p className="mt-1 text-xs leading-5 text-slate-600 dark:text-slate-300">
              {detail}
            </p>
          ) : null}
        </div>

        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-white text-indigo-700 shadow-sm ring-1 ring-slate-200 dark:bg-slate-900 dark:text-indigo-300 dark:ring-slate-700">
          {icon}
        </div>
      </div>
    </article>
  );
}

export default function PartenairesKpiCards({ stats, filteredStats, loading }) {
  return (
    <section className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <KpiCard
        label="Partenaires"
        value={stats.total}
        detail={`${filteredStats.total} affiché(s) avec les filtres`}
        icon={<FaHandshake />}
        loading={loading}
        tone="info"
      />

      <KpiCard
        label="Affichés"
        value={stats.active}
        detail={`${stats.inactive} partenaire(s) masqué(s)`}
        icon={<FaEye />}
        loading={loading}
        tone="ok"
      />

      <KpiCard
        label="Pages détail"
        value={stats.withDetail}
        detail={`${stats.withoutDetail} sans page détail`}
        icon={<FaEyeSlash />}
        loading={loading}
        tone={stats.withDetail ? "base" : "warn"}
      />

      <KpiCard
        label="Logos"
        value={stats.withLogo}
        detail={`${stats.withoutLogo} logo(s) manquant(s)`}
        icon={<FaImage />}
        loading={loading}
        tone={stats.withoutLogo ? "warn" : "base"}
      />
    </section>
  );
}